import CartOverview from "containers/CartOverview/CartOverview";
import Checkout from "containers/Checkout/Checkout";
import Home from "containers/Home/Home";
import VendingMachineDispense from "containers/VendingMachineDispense/VendingMachineDispense";

//Defines total pages we will be showing in our app
export const APP_ROUTES = {
  HOME_PAGE: { url: "/", component: Home },
  CART_PAGE: { url: "/cart", component: CartOverview },
  CHECKOUT_PAGE: { url: "/checkout", component: Checkout },
  DISPENSING_ITEMS: {
    url: "/vending-machine-dispense/:orderId/:cartId",
    rawUrl: "/vending-machine-dispense/",
    component: VendingMachineDispense,
  },
};
